<template>
  <b-container class="customer-list">
    <div class="d-flex align-items-center mt-2 mb-3 px-3">
      <h4 class="mr-auto mt-2">Danh sách khách hàng</h4>
      <b-button variant="primary" to="/customer-detail">
        <b-icon icon="person-plus"></b-icon>
        Tạo mới
      </b-button>
    </div>
    <b-card class="card-border-top mb-5">
      <b-input-group class="input-group-sm">
        <b-form-input
          v-model="searchName"
          placeholder="Nhập tên khách hàng"
        ></b-form-input>
      </b-input-group>
      <b-table borderless :items="datas" :fields="fields" class="content">
        <template #cell(stt)="data">
          {{ data.index + 1 }}
        </template>
        <template #cell(name)="row">
          <b-link :to="'/customer-detail/' + row.item.id">{{
            row.value
          }}</b-link>
        </template>
        <template #cell(action)="row">
          <b-button-group>
            <b-button
              variant="outline-primary"
              size="sm"
              :to="'/customer-detail/' + row.item.id"
              >Cấu hình</b-button
            >
            <b-button
              variant="danger"
              size="sm"
              @click="onDeleteClick(row.item.id)"
            >
              <b-icon icon="trash"></b-icon>
            </b-button>
          </b-button-group>
        </template>
      </b-table>
    </b-card>
    <b-overlay :show="busyLayout" no-wrap @shown="onShownDeleteConfirm">
      <template #overlay>
        <div
          ref="deleteConfirmDialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p>
            <strong id="form-confirm-label"
              >Toàn bộ cược và cài đặt liên quan đến khách này sẽ bị xóa và
              không thể khôi phục lại được. Bạn chắc chắn muốn xóa?</strong
            >
          </p>
          <div class="d-flex">
            <b-button
              variant="outline-danger"
              class="mr-3"
              @click="onCancelDelete"
            >
              Không
            </b-button>
            <b-button variant="outline-success" @click="onOkDelete"
              >Xóa</b-button
            >
          </div>
        </div>
      </template>
    </b-overlay>
  </b-container>
</template>
<script>
// @ is an alias to /src
import { mapGetters } from "vuex";

export default {
  name: "CustomerList",
  data() {
    return {
      fields: [
        "stt",
        { key: "name", label: "Tên", sortDirection: "asc", class: "text-left" },
        { key: "warning", label: "Cảnh báo", class: "text-left" },
        { key: "action", label: "Action", class: "text-right" }
      ],
      datas: [],
      busyLayout: false,
      deleteId: 0,
      searchName: ""
    };
  },
  watch: {
    players: function(p) {
      if (this.players.length > 0) {
        this.datas = p.map(e => {
          return {
            id: e.id,
            name: e.name,
            warning: e.warning == 0 ? "Không" : "Có",
            created_at: e.created_at
          };
        });
      }
    },
    searchName: function(search) {
      let d = this.players.filter(e => {
        return e.name.toLowerCase().includes(search.toLowerCase());
      });
      this.datas = d.map(e => {
        return {
          id: e.id,
          name: e.name,
          warning: e.warning == 0 ? "Không" : "Có",
          created_at: e.created_at
        };
      });
    }
  },
  created() {
    this.datas = this.players.map(e => {
      return {
        id: e.id,
        name: e.name,
        warning: e.warning == 0 ? "Không" : "Có",
        created_at: e.created_at
      };
    });
  },
  computed: {
    ...mapGetters(["players"])
  },
  methods: {
    onShownDeleteConfirm() {
      this.$refs.deleteConfirmDialog.focus();
    },
    onCancelDelete() {
      this.busyLayout = false;
    },
    async onOkDelete() {
      if (this.deleteId == 0) {
        this.busyLayout = false;
        return;
      }
      await this.$http.delete("player/" + this.deleteId);
      this.deleteId = 0;
      this.busyLayout = false;
      this.$store.dispatch("getPlayers");
    },
    onDeleteClick(playerId) {
      this.deleteId = playerId;
      this.busyLayout = true;
    }
  }
};
</script>
